import { format, isAfter, isWithinInterval, parse } from 'date-fns';

export const formatDateTime = (date: Date | number) =>
  format(date, 'yyyy-MM-dd HH:mm:ss');

export const formatDateOnly = (date: Date | number) =>
  format(date, 'yyyy-MM-dd');
export const parseDateOnly = (value: string) =>
  parse(value, 'yyyy-MM-dd', new Date());

export const formatTimeOnly = (date: Date | number) => format(date, 'HH:mm:ss');

export const parseTimeOnly = (value: string) =>
  parse(value, 'HH:mm:ss', new Date());

export const formatSimpleTime = (date: Date | number) => format(date, 'HH:mm');

export const isIntervalActive = (start: Date | number, end: Date | number) =>
  isAfter(end, start) &&
  isWithinInterval(new Date(), {
    start: start,
    end: end,
  });
